/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionTypeFromJSON, ApiConversionTypeToJSON, } from './ApiConversionType';
export function ApiUserActionConversionFromJSON(json) {
    return ApiUserActionConversionFromJSONTyped(json, false);
}
export function ApiUserActionConversionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : ApiConversionTypeFromJSON(json['type']),
    };
}
export function ApiUserActionConversionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'type': ApiConversionTypeToJSON(value.type),
    };
}
